export default "__VITE_ASSET__Ceg49fQI__"